/** @format */
import { createReducer, on } from '@ngrx/store';
import {
  attributeOptionsProcessed,
  selectAttributeOptionsUpdated,
  attributeValidationPerformed,
} from './attributes.actions';
import { AttributesState } from '@pdp/data-access/interfaces';

export const initialAttributeState: AttributesState = {
  allAttributeOptions: [],
  selectedAttributeOptions: [],
  errorList: null,
};

export const attributesReducers = createReducer(
  initialAttributeState,
  on(attributeOptionsProcessed, (state, { attributeOptions }) => ({
    ...state,
    allAttributeOptions: attributeOptions,
  })),
  on(selectAttributeOptionsUpdated, (state, { allSelectedAttributeOptions }) => {
    let updatedErrorList = state.errorList;

    // Clear errors for attributes that now have values
    if (state.errorList) {
      updatedErrorList = { ...state.errorList };

      // Check each selected attribute and remove it from error list
      allSelectedAttributeOptions.forEach((option) => {
        if (option.name in updatedErrorList) {
          delete updatedErrorList[option.name];
        }
      });

      // Set to null if no errors remain
      if (Object.keys(updatedErrorList).length === 0) {
        updatedErrorList = null;
      }
    }

    return {
      ...state,
      selectedAttributeOptions: allSelectedAttributeOptions,
      errorList: updatedErrorList,
    };
  }),
  on(attributeValidationPerformed, (state, { error }) => ({
    ...state,
    errorList: error,
  })),
);

export const attributesReducer = (state, action) => {
  return attributesReducers(state, action);
};
